import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortINRCurrency'
})
export class ShortINRCurrencyPipe implements PipeTransform {

    transform(number: number, args?: any): any {
        if (isNaN(number)) return null; // will only work value is a number
        if (number === null) return null;
        if (number === 0) return '₹'+number;
        let abs = Math.abs(number);
        const rounder = Math.pow(10, 1);
        const isNegative = number < 0; // will also work for Negetive numbers
        let key = '';

        const powers = [
            {key: 'Q', value: Math.pow(10, 15)},
            {key: 'T', value: Math.pow(10, 12)},
            {key: 'C', value: Math.pow(10, 7)},
            {key: 'L', value: Math.pow(10, 5)},
            {key: 'K', value: 1000}
        ];

        for (let i = 0; i < powers.length; i++) {
            let reduced = abs / powers[i].value;
            reduced = Math.round(reduced * rounder) / rounder;
            if (reduced >= 1) {
                abs = reduced;
                key = powers[i].key;
                break;
            }
            if ((i === powers.length-1 )&& (reduced < 1)){
                // If value is too small to be shown then round the digits.
                // ex: 5.82009999 => 5.8
                abs = Math.round(abs * rounder) / rounder;
            }
        }
        return '₹'+(isNegative ? '-' : '') + abs + key;
    }
}